import global from './global';

document.addEventListener('DOMContentLoaded', (event) => {
    global.init();
});
